module.exports = __webpack_public_path__ + "img/yunpingtai.c6ffd575.png";